import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-upload-modal',
  templateUrl: './upload-modal.component.html',
  styleUrls: ['./upload-modal.component.scss']
})
export class UploadModalComponent implements OnInit {

  	@Input() title: string;
  	@Input() isVisible: boolean;
	@Input() url: string;
	
	// tslint:disable-next-line:no-output-on-prefix
	@Output() onSuccess = new EventEmitter<boolean>();
	@Output() isVisibleChange = new EventEmitter<boolean>();

  	uploading = false;
	fileList: NzUploadFile[] = [];
	uploadDisable = false;
	

  	constructor(private http: HttpClient, private msg: NzMessageService) {}

	ngOnInit() {
	}

	beforeUpload = (file: NzUploadFile): boolean => {
		this.fileList.push(file);
		return false;
	}

	handleUpload(): void {
		const formData = new FormData();
		// tslint:disable-next-line:no-any
		this.fileList.forEach((file: any) => {
			formData.append('files', file);
		});		
		
		this.uploading = true;
		// You can use any AJAX library you like
		const req = new HttpRequest('POST', this.url, formData, {
			reportProgress: true
		});

		this.http
		.request(req)
		.pipe(filter(e => e instanceof HttpResponse))
		.subscribe(
		(event: {}) => {
			this.uploading = false;
			this.onSuccess.emit(true);
			this.msg.success('upload successfully.');
		},
		err => {
			this.uploading = false;
			this.msg.error('upload failed.');
		});
  	}

	handleCancel(): void {
		console.log('Button cancel clicked!');		
		this.isVisibleChange.emit(false);		
	}

	afterClose(): void {
		console.log('AfterClose');
		this.isVisibleChange.emit(false);
	}

	progress(event: any): void {
		console.log(event);
	}

	handleOk(){
		
	}

	test() { 
		console.log('test...');
	}
}
